export const ru = {
    'incorrect-ecommerce': 'Некорректно настроена передача данных Ecommerce',
    'new-auditory': 'Интересовались похожими товарами',
    'product-page-visit': 'Смотрели товары на моём сайте',
    'same-products': 'Обе группы',
    'similar-goods-for-search':
        'На поиске объявления будут показаны только аудитории, интересующейся похожими товарами.',
    'status-active': 'Активен',
    'status-hint-not-show': 'Показов нет',
    'status-hint-only-for-context': 'Показы только в сетях',
    'status-hint-show-not-everyone': 'Показывается не всем',
    'status-stopped': 'Выключен',
    'unavailable-for-search': 'Выбранный таргетинг исключает показы на поиске.'
};
